import { AutocompleteInput, NumberInput, minValue, ReferenceInput, required, TextInput } from "react-admin";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";

const PLACES_FIELDS = [
  { source: "studentStudyPlaces", label: "Бройка места за обучение на студенти" },
  { source: "studentInternshipPlaces", label: "Бройка места за практика на студенти" },
  { source: "staffTeachingPlaces", label: "Бройка места за обучение на преподаватели" },
  { source: "staffTrainingPlaces", label: "Бройка места за практика на преподаватели" },
];

const UniversityFields = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={8}
      >
        <ReferenceInput
          source="universityId"
          reference={administrationRequests.getUniversitiesSelect()}
        >
          <AutocompleteInput
            label="Университет"
            optionText="name"
            fullWidth
            validate={required()}
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          label="Максимален престой"
          source="maximumStay"
          fullWidth
          validate={required()}
        />
      </Grid>
      {PLACES_FIELDS.map(({ source, label }) => (
        <Grid
          item
          xs={12}
          md={3}
          key={source}
        >
          <NumberInput
            label={label}
            source={source}
            fullWidth
            min={0}
            validate={[required(), minValue(0)]}
            onWheel={e => e.target.blur()}
          />
        </Grid>
      ))}
      <Grid
        item
        xs={12}
      >
        <TextInput
          label="Коментар"
          source="comment"
          fullWidth
          multiline
          minRows={4}
        />
      </Grid>
    </Grid>
  );
};

export default UniversityFields;
